import { render } from "./WeatherComponent.vue?vue&type=template&id=63ffd4c8&scoped=true"
import script from "./WeatherComponent.vue?vue&type=script&lang=js"
export * from "./WeatherComponent.vue?vue&type=script&lang=js"

import "./WeatherComponent.vue?vue&type=style&index=0&id=63ffd4c8&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63ffd4c8"],['__file',"src/components/h5/data/WeatherComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "63ffd4c8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('63ffd4c8', __exports__)) {
    api.reload('63ffd4c8', __exports__)
  }
  
  module.hot.accept("./WeatherComponent.vue?vue&type=template&id=63ffd4c8&scoped=true", () => {
    api.rerender('63ffd4c8', render)
  })

}


export default __exports__